<template lang="pug">
    b-container(
      fluid,
      v-if="form && ($route.query.page == 'documents' || !$route.query.page)"
    )
      TableConfigModal(
        ref="configModal",
        :columns="columns",
        @update-columns="updateColumns"
      )
      b-row.my-1(v-if="currentproject")
        b-col(cols="2")
          .d-flex.justify-content-between.mb-1
          
        b-col(cols="8")
          div.ml-5(
            v-if="documents && (documents.find((x) => x.relations.selected) || select_all_query)"
          )
            .small.mr-2 Bulk-Operation ({{ select_all_query ? currentproject.relations.total_documents : documents.filter((x) => x.relations.selected).length }})
            div(style="width: 400px")
              b-select.form-control.w-100(
                variant="outline-secondary",
                size="sm",
                v-model="bulk_operation",
                @change="$emit('updateBulkOperation', bulk_operation)"
              )
                option(value="", selected, disabled) -- Bitte Operation auswählen --
                option(value="selected_kks") KKS(s) zuweisen
                option(value="selected_class") DCC(s) zuweisen
                option(value="should_be_splitted") Splits exportieren zuweisen
                option(value="rerun") Dokumente erneut verarbeiten
                option(value="extraction") Sachmerkmale Extrahieren
                option(value="export") Dateien Exportieren
                option(value="export_table") Tabelle-Exportieren (inkl. Sachmerkmale)
                option(value="delete" v-if="!select_all_query") Löschen
    
              div
                template(v-if="bulk_operation == 'extraction'")
                  el-select.select-primary.pagination-select.w-100.mt-1(
                    size="sm",
                    v-model="bulk_value.selected_extraction",
                    placeholder="Extraktions-Schema",
                    :filterable="true"
                  )
                    template(v-if="checklists")
                      el-option(
                        v-for="item in checklists",
                        :key="item._id",
                        :label="item.name",
                        :value="item._id"
                      )
    
                  .mt-1
                    b-input-group
                      b-select(v-model="bulk_value.overwrite_extraction", placeholder="Extraktion überschreiben")
                        option(:value="true") Merkmale überschreiben
                        option(:value="false") Merkmale nicht überschreiben
    
                  .small.mt-2 Achtung: Es können zusätzliche Kosten entstehen. Ggf. Extraktion freigeben lassen.
    
                template(v-if="bulk_operation == 'export'")
                  .small.mt-2
                    | Export-Ordner:
                  b-input.w-100(
                    placeholder="Zielordner name",
                    v-model="currentproject.export_dir_path"
                  )
    
                template(v-if="bulk_operation == 'selected_kks'")
                  el-select.select-primary.pagination-select.w-100.mt-1(
                    size="sm",
                    v-model="bulk_value.selected_kks",
                    placeholder="KKS(s)",
                    multiple,
                    :allow-create="true",
                    :filterable="true"
                  )
                    template(v-if="detail_list && detail_list.entries")
                      el-option(
                        v-for="item in detail_list.entries.map((x) => x.kks)",
                        :key="item",
                        :label="item",
                        :value="item"
                      )
    
                template(v-if="bulk_operation == 'selected_class'")
                  el-select.select-primary.pagination-select.w-100.mt-1(
                    size="sm",
                    v-model="bulk_value.selected_class",
                    placeholder="DCC",
                    multiple,
                    :allow-create="true",
                    :filterable="true"
                  )
                    template(v-if="detail_list && detail_list.all_classes")
                      el-option(
                        v-for="item in detail_list.all_classes",
                        :key="item",
                        :label="item",
                        :value="item"
                      )
    
                template(v-if="bulk_operation == 'should_be_splitted'")
                  .mt-1
                    b-input-group
                      b-select(v-model="bulk_value.should_be_splitted")
                        option(value="", selected, disabled) -- Auswahl --
                        option(value="true") Ja
                        option(value="false") Nein
    
                template(v-if="bulk_operation == 'export_original_as_complete'")
                  .mt-1
                    b-input-group
                      b-select(v-model="bulk_value.export_original_as_complete")
                        option(value="", selected, disabled) -- Auswahl --
                        option(value="true") Ja
                        option(value="false") Nein
    
                .mt-1
                  .float-right
                    b-button(
                      @click="bulkOperation(currentproject)",
                      size="sm",
                      variant="primary",
                      :disabled="!bulk_operation"
                    ) Bulk-Operation ausführen
    
        b-col(cols="2")
          .float-right
            b-button(
              @click="$refs.configModal.open(columns)",
              size="sm",
              variant="outline-secondary",
              v-b-tooltip.hover,
              title="Tabelle Konfigurieren"
            )
              i.fas.fa-gear.mr-1
    
            b-button(
              @click="deleteproject(currentproject)",
              size="sm",
              variant="outline-secondary",
              v-b-tooltip.hover,
              title="Projekt löschen"
            )
              i.fas.fa-trash.mr-1
    
      b-row
        b-col(cols="12")
          template(v-if="currentproject && documents")
            b-table-simple(
              responsive,
              small,
              sticky-header="600px",
              border-collapse="collapse",
              border-spacing="0",
              border="0",
              cellpadding="0",
              cellspacing="0"
            )
              thead
                b-tr
                  b-th
                    .d-flex.d-wrap.items-center
                      div
                        b-check.mr-2(
                          variant="primary",
                          v-model="select_all",
                          :value="true",
                          :unchecked-value="false",
                          @change="selectAllDocuments"
                        ) Seite
                        b-check.mr-2(
                          variant="primary",
                          v-model="select_all_query",
                          :value="true",
                          :unchecked-value="false"
                          @change="$emit('updateSelectAllQuery', select_all_query)"
                          ) Alle
    
                  // Loop through columns
                  template(v-for="column in columns" v-if="column.visible")
                    b-th(:key="column.key")
                      b-link(@click="sort_by = column.key; desc = !desc") {{ column.label }}
                        i.fa-solid.fa-chevron-down(v-if="sort_by == column.key && !desc")
                        i.fa-solid.fa-chevron-up(v-if="sort_by == column.key && desc")
    
                      // Filters for specific columns
                      template(v-if="column.key === 'filename'")
                        .mt-1
                          b-input(
                            v-model="filter.filename",
                            size="sm",
                            placeholder="Ordner/Name",
                            @input="getDocuments(currentproject, 1)",
                            style="width: 150px"
                          )
                      template(v-else-if="column.key === 'selected_kks'")
                        .mt-1
                          el-select(
                            v-model="filter.selected_kks",
                            placeholder="KKS",
                            multiple,
                            :allow-create="true",
                            size="sm",
                            :filterable="true",
                            :default-first-option="false",
                            @change="getDocuments(currentproject, 1)",
                            style="width: 200px"
                          )
                            template(v-if="detail_list && detail_list.entries")
                              el-option(
                                v-for="item in detail_list.entries.map((x) => x.kks)",
                                :key="item",
                                :label="item",
                                :value="item"
                              )
                      template(v-else-if="column.key === 'me_class'")
                        .mt-1
                          b-input(
                            v-model="filter.me_class",
                            size="sm",
                            placeholder="Filter",
                            @input="getDocuments(currentproject, 1)",
                            style="width: 150px"
                          )
                      template(v-else-if="column.key === 'selected_dcc'")
                        .mt-1
                          el-select(
                            v-model="filter.selected_class",
                            placeholder="DCC",
                            multiple,
                            :allow-create="true",
                            size="sm",
                            :filterable="true",
                            :default-first-option="false",
                            @change="getDocuments(currentproject, 1)",
                            style="width: 200px"
                          )
                            template(v-if="detail_list && detail_list.all_classes")
                              el-option(
                                v-for="item in detail_list.all_classes",
                                :key="item",
                                :label="item",
                                :value="item"
                              )
                      template(v-else-if="column.key === 'reviewed'")
                        .mt-1
                          b-select(
                            v-model="filter.reviewed",
                            size="sm",
                            placeholder="Filter",
                            @input="getDocuments(currentproject, 1)",
                            style="width: 150px"
                          )
                            option(:value="null") Alle
                            option(:value="true") Geprüft
                            option(:value="false") Nicht geprüft
                      template(v-else-if="column.key === 'reviewed_comments'")
                        .mt-1
                          b-input(
                            v-model="filter.reviewed_comment",
                            size="sm",
                            placeholder="Kommentar suchen",
                            @input="getDocuments(currentproject, 1)",
                            style="width: 150px"
                          )
    
              b-tr(
                v-if="loadingDocuments",
                style="height: 100%; position: absolute; width: 100%; z-index: 1000; background-color: rgba(255, 255, 255, 0.2)"
              )
                b-td(colspan="100%")
                  .d-flex.justify-content-center
                    i.fas.fa-spinner.fa-spin.text-primary.mt-2(style="font-size: 2rem")
    
              b-tr(v-for="(document, key) in documents" :key="document._id")
                b-td
                  .clamp-2
                    .d-flex.text-nowrap
                      template(v-if="select_all_query")
                        b-form-checkbox.mr-1(checked, :disabled="true")
                      template(v-else)
                        b-check.mr-1(
                          v-model="document.relations.selected",
                          variant="primary",
                          :value="true",
                          :unchecked-value="false",
                          :id="document._id"
                        )
                      
    
                // Loop through columns
                template(v-for="column in columns" v-if="column.visible")
                  b-td(:key="column.key")
                    div(v-if="column.key === 'filename'")
                        .small.text-muted {{ document.page_number }} {{ document.filepath.replace('General/', '').replace(document.filename, '') }}
                        i(v-if="!document.status") - In Bearbeitung
                        b-link.text-decoration-none(
                          @click="pdfModal.open(document, checklists)"
                          :class="{ 'font-italic': document.status != 'completed' && !document.page_count }"
                        ) {{ document.filename }}
                    
                    div(v-else class="clamp-2")
                      div(v-if="column.key === 'action'")
                        <b-button variant="link" size="sm" @click="deleteDocument(currentproject, document)" href="javascript:void(0)" v-b-tooltip.hover title="Dokument aus Projekt entfernen">
                          <i class="fas fa-trash mr-1"></i>
                        </b-button>
                      div(v-else)
                        
                        span(v-html="getCellContent(column.key, document)")
    
            b-pagination(
              v-model="currentPage",
              :total-rows="currentproject.relations.total_documents",
              :per-page="50",
              aria-controls="my-table"
            )
    </template>
    
    <script>
    import TableConfigModal from './TableConfigModal.vue';
    import draggable from 'vuedraggable';
    
    export default {
      name: 'DocumentList',
      components: {
        TableConfigModal,
        draggable,
      },
      props: {
        form: Boolean,
        currentproject: Object,
        documents: Array,
        select_all_query: Boolean,
        bulk_operation: String,
        bulk_value: Object,
        checklists: Array,
        detail_list: Object,
        filter: Object,
      
     
        loadingDocuments: Boolean,
        pdfModal: Object
      },
      data() {
        return {
          currentPage: 1,
          sort_by: 'filename',
          desc: false,
          select_all: false,
          columns: [
            { key: 'filename', label: 'Dokument', visible: true },
            { key: 'selected_kks', label: 'KKS', visible: true },
            /*{ key: 'me_class', label: 'M/E', visible: true },*/
            { key: 'selected_dcc', label: 'DCC(s)', visible: true },
            { key: 'reviewed', label: 'Prüfung', visible: true },
            { key: 'reviewed_comments', label: 'Kommentare', visible: true },
            { key: 'page_count', label: 'Seiten', visible: true },
            { key: 'original_filesize', label: 'Original-Größe', visible: false },
            { key: 'compressed_filesize', label: 'Kompr.-Größe', visible: false },
            { key: 'extracted_information_count', label: 'Merkmale', visible: true },
            { key: 'has_toc', label: 'Inhaltsverz.', visible: true },
            { key: 'best_date_datetime', label: 'Datumsangabe', visible: true },
            { key: 'problems', label: 'Gefundene Probleme', visible: true },
            { key: 'action', label: 'Aktion', visible: true },
          ],
        };
      },


      watch: {
        currentPage(newValue, oldValue) {
          this.$emit('getDocuments', this.currentproject, newValue);
        },
        
        sort_by(newValue, oldValue) {

          if (newValue == oldValue) {
            this.desc = !this.desc;
          } else {
            this.desc = true;
          }
          
          this.$emit('getDocuments', this.currentproject, this.currentPage, true, newValue, this.desc);
        },

        desc(newValue, oldValue) {
          
          this.$emit('getDocuments', this.currentproject, this.currentPage, true, this.sort_by, newValue);
        
        },

       
      },

      mounted() {
        // Load columns from localstorage
        let columns = localStorage.getItem('documentListColumns');
        if (columns) {
          this.columns = JSON.parse(columns);
        }
      },
      
      methods: {
        bulkOperation(project) {
          this.$emit('bulkOperation', project, this.bulk_operation, this.bulk_value);
        },
        deleteproject(project) {
          this.$emit('deleteproject', project);
        },
        getDocuments(project, page) {
          this.$emit('getDocuments', project, page, true, this.sort_by, this.order_by);
        },
        deleteDocument(project, document) {
          this.$emit('deleteDocument', project, document);
        },
        updateColumns(newColumns) {
          this.columns = newColumns;
          // save to localstorage
          localStorage.setItem('documentListColumns', JSON.stringify(newColumns));
        },
        selectAllDocuments() {
          this.documents.forEach((x) => (x.relations.selected = this.select_all));
        },
        configModal: {
          open() {
            this.$refs.configModal.open(this.columns);
          },
        },
        getCellContent(columnKey, document) {
          switch (columnKey) {
            case 'filename':
              return document.filename;
            case 'selected_kks':
              return document.selected_kks ? document.selected_kks.join(', ') : '';
            case 'me_class':
              return document.me_class || '';
            case 'selected_dcc':
              return document.selected_class ? document.selected_class.join(', ') : '';
            case 'reviewed':
              if (document.status === 'completed') {
                let content = '';
                if (document.reviewed) {
                  content += '<i class="fas fa-check-circle text-success mr-1"></i> Geprüft';
                }
                return content;
              } else {
                return '';
              }
            case 'reviewed_comments':
              if (document.status === 'completed') {
                let content = '';
                if (document.reviewed_comment) {
                  content += `Kommentar: ${document.reviewed_comment.replace(/\n/g, '<br>')}`;
                }
                if (document.reviewed_comment_internal) {
                  content += `<br>Intern: ${document.reviewed_comment_internal.replace(/\n/g, '<br>')}`;
                }
                return content;
              } else {
                return '';
              }
            case 'page_count':
              return document.page_count || '';
            case 'original_filesize':
              return document.original_filesize ? this.formatFilesize(document.original_filesize) : '';
            case 'compressed_filesize':
              if (document.compressed_filesize) {
                let size = this.formatFilesize(document.compressed_filesize);
                if (document.original_filesize && document.original_filesize > 0) {
                  let savings = ((1 - document.compressed_filesize / document.original_filesize) * 100).toFixed(1);
                  size += ` <small class="text-muted">(-${savings}%)</small>`;
                }
                return size;
              }
              return '';
            case 'extracted_information_count':
              return document.extracted_information_count || '';
            case 'has_toc':
              let toc = document.has_toc ? 'Ja' : 'Nein';
              if (document.has_extracted_toc) toc += ' (extrahiert)';
              return toc;
            case 'best_date_datetime':
              if (document.best_date_datetime) {
                let dateStr = document.best_date_datetime.substring(0, 10);
                if (document.best_date) {
                  dateStr += ` (${document.best_date})`;
                }
                return dateStr;
              }
              return '';
            case 'problems':
              if (document.status === 'completed') {
                let problems = [];
                if (!document.selected_class) problems.push('Keine Klassifizierung');
                if (!document.selected_kks) problems.push('Keine KKS');
                return problems.join('<br>');
              } else {
                return `<small class="text-muted" v-b-popover.hover.top="${document.status_comment}">${this.$t('documentstatus.' + document.status)}</small>`;
              }
            case 'action':
              return `
                <b-button variant="link" size="sm" @click="deleteDocument(currentproject, document)" href="javascript:void(0)" v-b-tooltip.hover title="Dokument aus Projekt entfernen">
                  <i class="fas fa-trash mr-1"></i>
                </b-button>
              `;
            default:
              return '';
          }
        },
        formatFilesize(bytes) {
          if (!bytes || bytes === 0) return '0 B';
          const k = 1024;
          const sizes = ['B', 'KB', 'MB', 'GB'];
          const i = Math.floor(Math.log(bytes) / Math.log(k));
          return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
        },
      },
    };
    </script>
    
    <style scoped>
    .column-item {
      display: flex;
      align-items: center;
      margin-bottom: 5px;
    }
    .handle {
      cursor: move;
    }
    </style>
